<!-- 左中 -->
<template>
    <div class='bg box_v'>
        <div class="title">生源性别状况统计</div>
        <div class="card2box box box_v">
          <div class="card2boxtop">
            <div><span></span><span>男</span></div>
            <div><span></span><span>女</span></div>
          </div>
          <div class="itemwrapper box">
            <div v-for="(item,index) in list" :key="`cheifage_${index}`" class="item box">
              <div class="item box box_v">
                <div class="itemTitle">{{item.stylePercent*10}}人</div>
                <div class="histogram" :style="'marginBottom:'+(item.stylePercent+23)+'px'">
                    <div></div>
                    <div :style="'height:'+(item.stylePercent)+'px'"></div>
                    <div :style="'height:'+(item.stylePercent)+'px'"></div>
                </div>
              </div>
              <div class="item box box_v">
                <div class="itemTitle">{{item.stylePercent1*10}}人</div>
                <div class="histogram1" :style="'marginBottom:'+(item.stylePercent1+23)+'px'">
                    <div></div>
                    <div :style="'height:'+(item.stylePercent1)+'px'"></div>
                    <div :style="'height:'+(item.stylePercent1)+'px'"></div>
                </div>
              </div>
              <div class="bottombg"></div>
            </div>
          </div>
          <div class="itemLabelbox">
            <div v-for="(item,index) in listname" class="itemLabel">{{item}}</div>
          </div>
        </div>
    </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
    return {
        list:[{stylePercent:11.5,stylePercent1:22.2},{stylePercent:41.5,stylePercent1:22.2},{stylePercent:21.5,stylePercent1:22.2}],
        listname:['幼升小','五升六','小升初'],
      }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftcenter.png');
    background-size: 100% 100%;
    margin-bottom:10px;
    margin-top:10px;
    height:100%;
    padding-bottom: 20px;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}
.card2box{width: 100%;margin-top: 18px;justify-content: flex-end;height: 100%;}
.card2boxtop{width: 100%;display: flex;display: -webkit-flex;justify-content: center;align-items: center;height: 16px;}
.card2boxtop div{display: flex;display: -webkit-flex;justify-content: center;align-items: center;height: 16px;}
.card2boxtop div span:nth-child(1){width: 16px;height: 12px;background: #34B5FF;border-radius: 2px;}
.card2boxtop div span:nth-child(2){font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #FEFEFE;margin-left: 5px;}
.card2boxtop div:nth-child(2){margin-left: 44px;}
.card2boxtop div:nth-child(2) span:nth-child(1){background:#FF80C3;}


.colorName{
	color:black;
}
.item{
	justify-content: flex-end;position: relative;
  width: 108px;
}
.cylinder {
  position: relative;
	transform: rotateX(70deg);
	margin:0 auto
}

.ellipse {
    width: 30px;
    height: 30px;
    background: #00A0E9;
    border-radius: 15px;
}
.ellipse1 {
    width: 30px;
    height: 30px;
    background: #41D6BC;
    border-radius: 15px;
}
.rectangle1{
  width: 30px;
  height: 200px;
  position: absolute;
  background: linear-gradient(90deg, #41D6BC 0%, rgba(65, 214, 188, 0.2) 63%, #41D6BC 100%);
  top: 0;
  left: 0;
  border-radius: 15px;
  z-index: -1;
}
.rectangle {
    width: 30px;
    height: 200px;
    position: absolute;
    background: linear-gradient(90deg, #0084FF 0%, rgba(0, 127, 246, 0.2) 63%, #017CF1 100%);
    top: 0;
    left: 0;
    border-radius: 15px;
    z-index: -1;
}

.itemTitle{
	font-size: 14px;
	color: #27BBFF;
	text-align: center;
	white-space: pre-wrap;
}
.itemLabelbox{display: flex;justify-content: space-around;margin-top: -10px;}
.itemLabel{
	font-size: 14px;
	color: #fff;
	text-align: center
}
.itemwrapper{
  display: flex;justify-content: space-around;
	height:100%;margin-top: 20px;
}
.bottombg{width: 108px;height: 18px;border-radius: 9px;background: linear-gradient(0deg, #005DB8 0%, rgba(6, 27, 84, 0) 100%);position: absolute;bottom:15px;z-index: -1;}


.histogram {
  position: relative;margin-top: 10px;width: 30px;margin-left: 12px;
}
/* 顶部平行四边形 */
.histogram div:nth-child(1) {
  position: absolute;
  top: -3.95px;
  left:7.8px;
  color: white;
  background: #4BC9FB;
  width: 15.5112862px;
  height:3.94px;
  transform: skew(-75.43deg,14.57deg);opacity: 0.8;
}
/* 右侧平行四边形 */
.histogram div:nth-child(2) {
  position: absolute;
  top: 0px;
  left:16px;
  background: linear-gradient(0deg, #50D0FC 0%, #278EF1 100%);
  width: 15.5112862px;
  height: 50px;
  transform: skewY(-14.57deg);opacity: 0.8;
}
/* 正面矩形 */
.histogram div:nth-child(3) {
  position: absolute;
  top: 0px;
  left: 0;
  background: linear-gradient(0deg, #50D0FC 0%, #278EF1 100%);
  width: 15.5112862px;
  height: 50px;
  transform: skewY(14.57deg);opacity: 0.8;
}
.histogram1 {
  position: relative;margin-top: 10px;width: 30px;margin-left: 12px;
}
/* 顶部平行四边形 */
.histogram1 div:nth-child(1) {
  position: absolute;
  top: -3.95px;
  left:7.8px;
  color: white;
  background: #FF80C3;
  width: 15.5112862px;
  height:3.94px;
  transform: skew(-75.43deg,14.57deg);opacity: 0.8;
}
/* 右侧平行四边形 */
.histogram1 div:nth-child(2) {
  position: absolute;
  top: 0px;
  left:16px;
  background: linear-gradient(0deg, #D74DFF 0%, #FF7FA6 100%);
  width: 15.5112862px;
  height: 50px;
  transform: skewY(-14.57deg);
  opacity: 0.8;
}
/* 正面矩形 */
.histogram1 div:nth-child(3) {
  position: absolute;
  top: 0px;
  left: 0;
  background: linear-gradient(0deg, #D74DFF 0%, #FF7FA6 100%);
  width: 15.5112862px;
  height: 50px;
  transform: skewY(14.57deg);
  opacity: 0.8;
}

</style>
